import { Action } from "redux";
import { IProductList, IMontanaFacet, IProfessionalList } from "@montana/models/generated/cms.interface";
import { SortingOption } from "@montana/models/dev";

export type IFilterAction = IApplySingleFacetFilterAction
    | IClearFilterAction
    | IInitFilterAction
    | ILoadMoreFilterAction
    | IRemoveSingleFacetFilterAction
    | IUpdateFilterResultAction
    | IApplySearchFilterAction
    | IApplySortingFilterAction
    | IApplyFacetsAction;

export enum FilterActionTypes {
    APPLY_FACETS = "@@filter/APPLY_FACETS",
    APPLY_SINGLE_FACET = "@@filter/APPLY_SINGLE_FACET",
    APPLY_SEARCH = "@@filter/APPLY_SEARCH",
    APPLY_SORTING = "@@filter/APPLY_SORTING",
    CLEAR_FILTER = "@@filter/CLEAR_FILTER",
    INIT_FILTER = "@@filter/INIT_FILTER",
    LOAD_MORE = "@@filter/LOAD_MORE",
    REMOVE_SINGLE_FACET = "@@filter/REMOVE_SINGLE_FACET",
    UPDATE_FILTER_RESULT = "@@filter/UPDATE_FILTER_RESULT",
}

export interface IInitFilterAction extends Action<FilterActionTypes.INIT_FILTER> {
    filterId: number;
    filterLanguage: string;
}

export const initFilter = (filterId: number, filterLanguage: string): IInitFilterAction => ({
    type: FilterActionTypes.INIT_FILTER,
    filterId,
    filterLanguage,
});

export type ILoadMoreFilterAction = Action<FilterActionTypes.LOAD_MORE> & { customerMode: string };

export const loadMore = (customerMode: string): ILoadMoreFilterAction => ({
    type: FilterActionTypes.LOAD_MORE,
    customerMode
});

export interface IApplySortingFilterAction extends Action<FilterActionTypes.APPLY_SORTING> {
    sortBy: SortingOption;
}

export const applySorting = (sortBy: SortingOption): IApplySortingFilterAction => ({
    type: FilterActionTypes.APPLY_SORTING,
    sortBy,
});

export interface IApplyFacetsAction extends Action<FilterActionTypes.APPLY_FACETS> {
    facets: IMontanaFacet[];
}

export const applyFacets = (facets: IMontanaFacet[]): IApplyFacetsAction => ({
    type: FilterActionTypes.APPLY_FACETS,
    facets,
});

export interface IApplySingleFacetFilterAction extends Action<FilterActionTypes.APPLY_SINGLE_FACET> {
    facet: IMontanaFacet;
}

export const applySingleFacet = (facet: IMontanaFacet): IApplySingleFacetFilterAction => ({
    type: FilterActionTypes.APPLY_SINGLE_FACET,
    facet,
});

export interface IApplySearchFilterAction extends Action<FilterActionTypes.APPLY_SEARCH> {
    searchQuery: string;
}

export const applySearch = (searchQuery: string): IApplySearchFilterAction => ({
    type: FilterActionTypes.APPLY_SEARCH,
    searchQuery,
});

export interface IRemoveSingleFacetFilterAction extends Action<FilterActionTypes.REMOVE_SINGLE_FACET> {
    facet: IMontanaFacet;
}

export const removeSingleFacet = (facet: IMontanaFacet): IRemoveSingleFacetFilterAction => ({
    type: FilterActionTypes.REMOVE_SINGLE_FACET,
    facet,
});

export interface IClearFilterAction extends Action<FilterActionTypes.CLEAR_FILTER> {
    customerMode: string;
}

export const clearFilter = (customerMode: string): IClearFilterAction => ({
    type: FilterActionTypes.CLEAR_FILTER,
    customerMode
});

export interface IUpdateFilterResultAction extends Action<FilterActionTypes.UPDATE_FILTER_RESULT> {
    productList: IProductList | IProfessionalList;
    searchQuery: string;
    appliedFacets: IMontanaFacet[];
    sortBy: SortingOption;
    replace: boolean;
}

export const updateFilterResult = (productList: IProductList | IProfessionalList, searchQuery: string, appliedFacets: IMontanaFacet[], sortBy: SortingOption, replace: boolean): IUpdateFilterResultAction => ({
    type: FilterActionTypes.UPDATE_FILTER_RESULT,
    productList: productList,
    searchQuery,
    appliedFacets,
    sortBy,
    replace,
});
